(function () {
  if (window.__sparkCardSliderInit) return;
  window.__sparkCardSliderInit = true;

  // Same shape as the hero zoom modal's slideIndex/step/updateNav in product-modal.js; keep them in step.
  // The inline slider and the zoom lightbox are both a [data-card-slider] root holding a
  // .spark-card-slider__track plus prev/next/current/total hooks, so every function below serves both.
  function track(root) { return root.querySelector('.spark-card-slider__track'); }

  function pageWidth(t) {
    var first = t.firstElementChild;
    if (!first) return 0;
    return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(t).columnGap) || 0);
  }

  var dialog;
  var dialogIndex = 0;

  function update(root) {
    var t = track(root);
    if (!t) return;
    var atStart = t.scrollLeft <= 2;
    var atEnd = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    root.querySelectorAll('[data-card-slider-prev]').forEach(function (b) { b.disabled = atStart; });
    root.querySelectorAll('[data-card-slider-next]').forEach(function (b) { b.disabled = atEnd; });
    var cur = root.querySelector('[data-card-slider-current]');
    var w = pageWidth(t);
    if (root === dialog && w) dialogIndex = Math.round(t.scrollLeft / w);
    if (cur && w) {
      var perPage = Math.max(1, Math.round(t.clientWidth / w));
      var n = atEnd ? t.children.length : Math.min(t.children.length, Math.round(t.scrollLeft / w) + perPage);
      if (cur.textContent != n) cur.textContent = n;
    }
  }

  // Pages by what is visible: 3 cards on desktop, 1 on mobile and in the lightbox.
  function step(root, dir) {
    var t = track(root);
    var w = t && pageWidth(t);
    if (!w) return;
    var perPage = Math.max(1, Math.round(t.clientWidth / w));
    t.scrollBy({ left: dir * w * perPage, behavior: 'smooth' });
  }

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'spark-card-lightbox';
    dialog.setAttribute('data-card-slider', '');
    dialog.innerHTML =
      '<button type="button" class="spark-card-lightbox__close">&times;</button>' +
      '<ul class="spark-card-slider__track spark-card-lightbox__track" role="list"></ul>';
    // The nav strip pages the track; any other tap (image, backdrop, X) closes.
    dialog.addEventListener('click', function (e) {
      if (!e.target.closest('.spark-card-lightbox__nav')) dialog.close();
    });
    document.body.appendChild(dialog);
  }

  // Rebuilds the lightbox from the clicked slider's own cards and controls, opened at the tapped card.
  function openZoom(root, zoom) {
    if (!dialog) buildDialog();
    var zooms = Array.prototype.slice.call(root.querySelectorAll('.spark-card-slider__zoom'));
    var start = Math.max(0, zooms.indexOf(zoom));
    var t = track(dialog);
    t.textContent = '';
    zooms.forEach(function (z, i) {
      var li = document.createElement('li');
      li.className = 'spark-card-lightbox__slide';
      var img = document.createElement('img');
      img.className = 'spark-card-lightbox__img';
      img.loading = Math.abs(i - start) <= 1 ? 'eager' : 'lazy';
      img.src = z.getAttribute('data-zoom-src');
      img.alt = z.getAttribute('data-zoom-alt') || '';
      li.appendChild(img);
      t.appendChild(li);
    });
    dialog.setAttribute('aria-label', root.getAttribute('data-dialog-label') || '');
    dialog.querySelector('.spark-card-lightbox__close').setAttribute('aria-label', root.getAttribute('data-close-label') || '');
    var old = dialog.querySelector('.spark-card-lightbox__nav');
    if (old) old.remove();
    var controls = root.querySelector('.spark-card-slider__controls');
    if (controls && zooms.length > 1) {
      var nav = controls.cloneNode(true);
      nav.classList.add('spark-card-lightbox__nav');
      dialog.appendChild(nav);
    }
    dialog.showModal();
    t.scrollLeft = start * t.clientWidth;
    update(dialog);
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-card-slider-prev], [data-card-slider-next]');
    if (arrow) {
      step(arrow.closest('[data-card-slider]'), arrow.hasAttribute('data-card-slider-prev') ? -1 : 1);
      return;
    }
    var zoom = e.target.closest('.spark-card-slider__zoom');
    if (zoom) openZoom(zoom.closest('[data-card-slider]'), zoom);
  });

  // On document, not the dialog: a disabled Next drops focus to body, outside the dialog.
  document.addEventListener('keydown', function (e) {
    if (!dialog || !dialog.open) return;
    if (e.key === 'ArrowLeft') step(dialog, -1);
    else if (e.key === 'ArrowRight') step(dialog, 1);
  });

  // scroll does not bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('spark-card-slider__track')) update(t.closest('[data-card-slider]'));
  }, true);

  function updateAll() {
    document.querySelectorAll('[data-card-slider]').forEach(update);
  }
  window.addEventListener('resize', function () {
    if (dialog && dialog.open) track(dialog).scrollLeft = dialogIndex * track(dialog).clientWidth;
    updateAll();
  });
  window.addEventListener('load', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  updateAll();
})();
